// localStorage key aligned with the existing SignUp.tsx consumer so the capture
// utility and the signup flow stay in sync without any migration.
const REFERRAL_STORAGE_KEY = 'pending_referral_code'

/** Call once on app load — captures ?ref= from the URL into local state for later use. */
export function captureReferralFromUrl(): string | null {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  const ref    = params.get('ref')
  if (!ref) return readStoredReferral()
  try {
    localStorage.setItem(REFERRAL_STORAGE_KEY, ref)
  } catch { /* storage full / denied — ignore */ }
  return ref
}

export function readStoredReferral(): string | null {
  try {
    return localStorage.getItem(REFERRAL_STORAGE_KEY)
  } catch {
    return null
  }
}

export function clearStoredReferral() {
  try {
    localStorage.removeItem(REFERRAL_STORAGE_KEY)
  } catch { /* ignore */ }
}
